import { defineAsyncComponent, defineComponent, h, type Component } from 'vue';

type RouteModule = { default: Component };

const RouteLoadingView = defineComponent({
  name: 'RouteLoadingView',
  setup() {
    return () => h('section', {
      class: 'route-loading-view',
      role: 'status',
      'aria-live': 'polite',
    }, [
      h('span', { class: 'route-loading-view__spinner', 'aria-hidden': 'true' }),
      h('span', 'Cargando sección…'),
    ]);
  },
});

const RouteLoadErrorView = defineComponent({
  name: 'RouteLoadErrorView',
  setup() {
    return () => h('section', { class: 'route-load-error', role: 'alert' }, [
      h('strong', 'No fue posible abrir esta sección.'),
      h('span', 'Revisa tu conexión e inténtalo de nuevo.'),
      h('button', { type: 'button', onClick: () => window.location.reload() }, 'Reintentar'),
    ]);
  },
});

/**
 * Keeps route confirmation synchronous while preserving a separate chunk for
 * each view. Vue Router otherwise waits for a route-level dynamic import before
 * it updates the URL and the active navigation state.
 */
export function immediateView(loader: () => Promise<RouteModule>): Component {
  const AsyncView = defineAsyncComponent({
    loader,
    loadingComponent: RouteLoadingView,
    errorComponent: RouteLoadErrorView,
    delay: 100,
    timeout: 30_000,
    onError(error, retry, fail, attempts) {
      if (attempts <= 2) window.setTimeout(retry, attempts * 500);
      else {
        console.error('No fue posible cargar la vista de la ruta.', error);
        fail();
      }
    },
  });

  return defineComponent({
    name: 'ImmediateRouteView',
    inheritAttrs: false,
    setup(_props, { attrs }) {
      return () => h(AsyncView, attrs);
    },
  });
}
